import domain from './domain';

// Reset notifications
export const resetNotifications = domain.createEvent('resetNotifications');
